import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HelpIcon } from '../common';
import './DriftMetricsCard.css';

function DriftMetricsCard({ driftSummary, meta }) {
    const navigate = useNavigate();
    const counts = driftSummary || { critical: 0, high: 0, medium: 0, low: 0, total: 0 };
    const hasEvents = counts.total > 0;

    // PRD-67 §4.3: three-class empty-state copy keyed off meta.
    // No "awaiting window" class — alarms are time-independent.
    const emptyMessage = (() => {
        if (hasEvents) return null;
        if (!meta) return 'No active drift alarms';
        const assetsScanned = meta.assetsScanned ?? 0;
        if (assetsScanned === 0) {
            return 'Run your first scan to see drift activity.';
        }
        // "Below threshold" — scans done, no open alarms.
        return 'No open drift alarms across scanned assets.';
    })();

    const handleSeverityClick = (severity) => {
        navigate(`/drift-alarms?severity=${severity}`);
    };

    const handleTitleClick = () => {
        navigate('/drift-alarms');
    };

    const severities = [
        { key: 'critical', label: 'Critical' },
        { key: 'high', label: 'High' },
        { key: 'medium', label: 'Medium' },
        { key: 'low', label: 'Low' }
    ];

    return (
        <div className="cm-metric-card cm-drift-metrics-card">
            <div className="metric-header">
                <span className="metric-icon">🔄</span>
                <span className="metric-label">
                    <span
                        className="drift-metrics-title"
                        onClick={handleTitleClick}
                        style={{ cursor: 'pointer' }}
                    >
                        Drift Alarms
                    </span>
                    <HelpIcon
                        content="Active drift alarms detected across your monitored assets. Drift alarms fire when your attack surface changes — new ports, expired certificates, DNS modifications, and more."
                        category="drift"
                    />
                </span>
            </div>
            <div className="drift-metrics-grid">
                {severities.map(sev => (
                    <div
                        key={sev.key}
                        className={`drift-metrics-item drift-metrics-item--${sev.key}`}
                        onClick={() => handleSeverityClick(sev.key)}
                    >
                        <span className={`drift-metrics-count${!hasEvents ? ' drift-metrics-count--zero' : ''}`}>
                            {counts[sev.key] || 0}
                        </span>
                        <span className="drift-metrics-label">{sev.label}</span>
                    </div>
                ))}
            </div>
            {!hasEvents && emptyMessage && (
                <div className="drift-metrics-empty-msg">{emptyMessage}</div>
            )}
        </div>
    );
}

export default DriftMetricsCard;
